module.exports = __webpack_public_path__ + "static/media/shurjoPay.d0e424dc.png";